import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLinkId, useSetButtonCode, useSetButtonId } from '../state';
import fetchWithToken from '../services';
import Loading from './Loading';

const SetButtonCode = () => {
    const linkId = useLinkId();
    const setButtonCode = useSetButtonCode();
    const setButtonId = useSetButtonId();
    const [isLoading, setIsLoading] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        const getUserId = async () => {
            try {
                const response = await fetchWithToken(`/link-to-button/${linkId}`, {
                    method: 'GET'
                });
                
                if (!response.ok) {
                    throw new Error(`Failed to fetch user data: ${response.status}`);
                }

                const data = await response.json();
                console.log('Data retrieved from link-to-button:', data);
                const { buttonId } = data;

                // Generate the button code snippet
                const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
                const buttonCodeSnippet = `<script
    src="${apiBaseUrl}/button-loader.js"
    id="${buttonId}"
    async></script>`;
                
                // Save the button code to context
                setButtonId(buttonId);
                setButtonCode(buttonCodeSnippet);
            } catch (error) {
                console.error('Error fetching user data:', error);
                navigate('/error');
            } finally {
                setIsLoading(false);
            }
        };

        getUserId();
    }, [linkId, setButtonCode, setButtonId, navigate, fetchWithToken]);

    if (isLoading) {
        return <Loading />;
    }

    return null; // The button code is set in context, no need to render anything
};

export default SetButtonCode;
